import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollRestoration = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll nach oben
    window.scrollTo({ top: 0, behavior: 'instant' });
    // Sicherstellen dass kein Scroll-Lock von Lightboxen hängen bleibt
    document.body.style.overflow = '';
  }, [pathname]);

  return null;
};

export default ScrollRestoration;
